var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    transform: "translate(-312 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Caminho_665",
    "data-name": "Caminho 665",
    transform: "translate(312 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,0A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z",
    stroke: "none",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17 2 C 12.99336051940918 2 9.226520538330078 3.560270309448242 6.393400192260742 6.393400192260742 C 3.560270309448242 9.226520538330078 2 12.99336051940918 2 17 C 2 21.00664138793945 3.560270309448242 24.77347946166992 6.393400192260742 27.60659980773926 C 9.226520538330078 30.43972969055176 12.99336051940918 32 17 32 C 21.00664138793945 32 24.77347946166992 30.43972969055176 27.60659980773926 27.60659980773926 C 30.43972969055176 24.77347946166992 32 21.00664138793945 32 17 C 32 12.99336051940918 30.43972969055176 9.226520538330078 27.60659980773926 6.393400192260742 C 24.77347946166992 3.560270309448242 21.00664138793945 2 17 2 M 17 0 C 26.38883972167969 0 34 7.611160278320313 34 17 C 34 26.38883972167969 26.38883972167969 34 17 34 C 7.611160278320313 34 0 26.38883972167969 0 17 C 0 7.611160278320313 7.611160278320313 0 17 0 Z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    transform: "translate(336 37)",
    fontSize: 24,
    fontFamily: "Montserrat-Light, Montserrat",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.656,
    y: 0
  }, "+")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.76c97788.svg";
export { ForwardRef as ReactComponent };